import { useQuery, useQueryClient } from "@tanstack/react-query";
import { APIHandlerOldDashboard } from "hooks/api-handler-old-dasboard";
import { APIHandlerV1 } from "hooks/api-handler-v1";

// default stale time and cache time settings
const DEFAULT_STALE_TIME = 30 * 60 * 1000; // in milliseconds
const DEFAULT_CACHE_TIME = 30 * 60 * 1000; // in milliseconds
//---------------------------//
export function useReactQuery({
  method,
  url,
  paramsData,
  isBioMechanics,
  isAbsoluteUrl,
  queryKey,
  skip = false,
  cacheTime = DEFAULT_CACHE_TIME,
  staleTime = DEFAULT_STALE_TIME,
  refetchOnMount,
  refetchOnWindowFocus,
  cache = true,
}) {
  const queryClient = useQueryClient();

  const query = useQuery({
    staleTime: cache ? staleTime : 1000,
    cacheTime: cache ? cacheTime : 1000,
    refetchOnWindowFocus: refetchOnWindowFocus || false,
    refetchOnMount: refetchOnMount || false,
    queryKey: queryKey,
    enabled: skip ? false : true,
    queryFn: async () => {
      const result = await APIHandlerOldDashboard({
        method,
        url,
        data: paramsData,
        isBioMechanics,
        isAbsoluteUrl,
      });
      return result.data;
    },
    onSuccess: (response) => {
      return response;
    },
    onError: (err) => {
      console.log("queryKey: ", queryKey, " Error: ", err);
    },
  });

  function inValidateQuery() {
    queryClient.invalidateQueries({ queryKey: queryKey });
  }

  return { ...query, inValidateQuery };
}
